var _defs, _style, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IB2cksfwAAAJ9QTFRFAAAAA8uIGtGSGdGSCs+KGtGSGtGSA86GBM6IFdCPYt60oOnR2PTs7ff22fTsn+nRFtGQBMyIKdSYT9uq0fLp+fr8zvLnTNqqK9WZS9upStqpKtKXBMqEy/LmzfLnFtGQE9GPX96zA82GI9OWaOC3nOnPGtKTf+TC1vPrjufJ7Pf2Cs+KHNKSm+nPHNKTA8uGzPHmGNGQS9qpBcyGLNOYOMvP1wAAADV0Uk5TAE+y3vnesU4+5ur//////+Q8XuL////jWu7vWzr//+P/60z///+u//////jc/65K/+LkN1fzn2nlAAAAwklEQVR4nF3Q2Q6CMBAF0FE2QRAQCwiUTdlRFvn/b7PQEoX70vYkk2YuwJLDkeN5QZTgl5OsnFVNu+iKYa52tW6IxXZcZnf0F89fZi20iRMQlNksxvQMI/KvwiyOmSYpHM/UHs/ng2qWA6dSw0WBqZYC8Np8qTAqCoSr+V43DEkI0hAULnssWxD1Pb7eICl7TDoAw95iP5CNTGe75viZl3e9TSETrcl3wpX6cVoLDaIkK+u6fCXD56/7NBeapn139PUFENQe7rMGraoAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Arrow 7",
    href: "#img1",
    x: 0,
    y: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.03556132.svg";
export { ForwardRef as ReactComponent };